
import Vue from 'vue';
import Component from 'vue-class-component';
import {Action, Getter} from 'vuex-class';
import {KullaniciBilgileriCevap} from '@/plugins/uyap-plugin/uyap/KullaniciBilgileri';
import {KimlikUyusmazligiUyarisi} from '@/types';

/**
 * Açık UYAP oturumu bu hesaba ait değil.
 *
 * Görsel dil DevreKesiciDialog ile aynı, ton kritik (kırmızı): burası bir güvenlik
 * sınırı. Kullanıcı hesabını başkasına verip, o kişinin e-imzasıyla açılmış oturum
 * üzerinden işlem yaptırabilir; bu yüzden uyarı bilgilendirici değil ENGELLEYİCİ.
 *
 * Uyarıyı kapatmak işlemleri geri açmaz — kapı UyapRequest içinde, her istekte
 * yeniden değerlendiriliyor. Bot DURAKLATILIR (görev hataya düşmez): 'hesap'|'kart' sebeplerinde
 * oturum doğrulanınca kendiliğinden devam eder; sunucu 423'ü ('lisans'|'lisans-tckn') ise
 * istemci karşılaştırmasından farklı olabileceği için yalnız "Yeniden bağla" ile (lisans
 * tazelenip bağlanılınca) devam eder. "Kapat" (ve başarısız "Yeniden bağla") botu 'dur' bırakır:
 * kapanınca duraklatma anısı da silinir, sonraki oturum doğrulaması botu kendiliğinden başlatmaz;
 * kullanıcı Başlat'a basar.
 */
@Component({})
export default class KimlikUyusmazligiDialog extends Vue {
  @Getter kimlikUyusmazligiUyarisi!: KimlikUyusmazligiUyarisi | null;
  @Getter uyapAvukatBilgileri!: KullaniciBilgileriCevap | undefined;
  @Getter hesapTckn!: string;
  @Action kimlikUyusmazligiUyarisiniKapat!: () => void;
  @Action kimlikUyusmazligiGiderildi!: (payload?: { kullanici?: boolean }) => void;
  @Action kimlikOnerisiniIsle!: (payload?: { neden?: string, zorla?: boolean }) => Promise<void>;
  @Action connectToUyap!: (payload?: { force?: boolean }) => Promise<void>;

  deneniyor = false;

  get acik(): boolean {
    return this.kimlikUyusmazligiUyarisi !== null;
  }

  set acik(v: boolean) {
    // persistent dialog; kapatma yalnızca düğmelerden.
    if (!v) this.kapat();
  }

  // Sunucu 423'ü: lisans sahibinin TCKN'si ile UYAP oturumunun TCKN'si farklı ('lisans') ya da
  // lisansta TCKN yok / lisans yok ('lisans-tckn').
  get lisansSebebi(): boolean {
    const sebep = this.kimlikUyusmazligiUyarisi?.sebep;
    return sebep === 'lisans' || sebep === 'lisans-tckn';
  }

  get sunucuMesaji(): string | null {
    return this.kimlikUyusmazligiUyarisi?.mesaj ?? null;
  }

  get baslik(): string {
    switch (this.kimlikUyusmazligiUyarisi?.sebep) {
      case 'lisans':
        return 'e-İmza lisans sahibinin oturumu değil';
      case 'lisans-tckn':
        return 'Bu büronun eİcraPro lisansı doğrulanamadı';
      default:
        return 'UYAP oturumu bu hesaba ait değil';
    }
  }

  get adimlar(): Array<{ baslik: string, metin: string }> {
    switch (this.kimlikUyusmazligiUyarisi?.sebep) {
      case 'lisans':
        return [
          {
            baslik: 'Lisans sahibinin e-imzasıyla bağlanın',
            metin: 'Bir eİcraPro lisansı altında yalnız lisans sahibinin e-imzası kullanılabilir.'
          },
          {
            baslik: 'Sonra yeniden bağlanın',
            metin: 'Lisans bilgisi tazelenir ve bağlantı kurulunca işlemleri Başlat ile sürdürebilirsiniz.'
          }
        ];
      case 'lisans-tckn':
        return [
          {
            baslik: 'Destek ile iletişime geçin',
            metin: 'Lisans sahibinin TC kimlik numarası kayıtlı olmalı ve büronun etkin bir eİcraPro lisansı bulunmalıdır.'
          },
          {
            baslik: 'Düzeltilince yeniden bağlanın',
            metin: 'Lisans bilgisi tazelenir ve bağlantı kurulunca işlemleri Başlat ile sürdürebilirsiniz.'
          }
        ];
      default:
        return [
          {
            baslik: 'Kendi hesabınızla giriş yapın',
            metin: 'Tarayıcıda başka bir kullanıcının hesabı açıksa çıkış yapıp kendi hesabınızla giriş yapın.'
          },
          {
            baslik: 'Kendi e-imzanızı takın',
            metin: 'Takılı kartın size ait olduğundan emin olun, sonra yeniden bağlanın.'
          }
        ];
    }
  }

  get oturumTckn(): string | null {
    return this.uyapAvukatBilgileri?.tcKimlikNo ?? null;
  }

  kapat() {
    this.kimlikUyusmazligiUyarisiniKapat();
  }

  async yenidenBaglan() {
    this.deneniyor = true;
    try {
      const lisans = this.lisansSebebi;
      // Sunucu kararı istemci karşılaştırmasından farklı olabilir: önce lisans/kimlik tazelenir.
      if (lisans) {
        await this.kimlikOnerisiniIsle({neden: 'kullanici', zorla: true});
      }
      // force: mevcut oturum "geçerli" görünse bile yeniden giriş yapılmalı —
      // sorun oturumun geçersizliği değil, YANLIŞ KİŞİYE ait olması.
      await this.connectToUyap({force: true});
      // Lisans sebeplerinde otomatik devam yok; kullanıcı bağlanmayı başardıysa işlemler sürer
      // (423 sürüyorsa bir sonraki next-task uyarıyı yeniden açar).
      if (lisans) {
        this.kimlikUyusmazligiGiderildi({kullanici: true});
      }
    } catch (e) {
      console.error('Yeniden bağlanma denemesi başarısız.', e);
    } finally {
      this.deneniyor = false;
      this.kapat();
    }
  }
}
